<template>
  <vxe-modal v-model="visible" :loading="loading" :title="$t('tab.shipmentRule')" type="confirm" width="40%" @confirm="confirm">
    <a-form-model ref="form" :colon="false" :label-col="labelCol" :model="rule" :rules="rules" :wrapper-col="wrapperCol">
      <a-row style="margin-left: -4%;margin-right: 4%">
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.packType')" prop="packType">
            <vxe-select v-model="rule.packType" :options="packTypes" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.shipOrder')" prop="shipOrder">
            <vxe-number-input v-model="rule.shipOrder" :min="1" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.owner')">
            <vxe-select v-model="rule.owner.id" :options="owners" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.orderType')">
            <vxe-select v-model="rule.orderType.id" :options="orderTypes" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.itemType')">
            <vxe-select v-model="rule.itemType.id" :options="itemTypes" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </vxe-modal>
</template>

<script>
import Vue from 'vue'
import { WAREHOUSE } from '@/store/mutation-types'
import { save } from '@/api/Api'
import { ShipmentRule } from '@/api/dto/config/ShipmentRule'
import { StorageRoom } from '@/api/dto/common/StorageRoom'

export default {
  name: 'ShipmentRuleEditor',
  data() {
    return {
      warehouse: Vue.ls.get(WAREHOUSE),
      visible: false,
      loading: false,
      rule: new ShipmentRule(),
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      rules: {
        packType: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        shipOrder: [{ required: true, message: this.$t('message.canNotBeEmpty') }]
      }
    }
  },
  props: {
    packTypes: {
      type: Array,
      default: []
    },
    owners: {
      type: Array,
      default: []
    },
    orderTypes: {
      type: Array,
      default: []
    },
    itemTypes: {
      type: Array,
      default: []
    }
  },
  methods: {
    add(storageRoom) {
      this.visible = true
      this.rule = new ShipmentRule()
      this.rule.storageRoom = new StorageRoom(storageRoom)
    },
    edit(row, copy) {
      this.visible = true
      if (copy) {
        row.id = undefined
        row.version = undefined
      }
      this.rule = new ShipmentRule(row)
    },
    save() {
      this.loading = true
      const rule = this.rule.toJSONObject()
      rule.warehouse = this.warehouse
      save('shipmentRulePersister', rule).then(res => {
        if (res.success) {
          this.$emit('success')
          this.$message.success(this.$t('message.saveSuccess'))
          this.visible = false
        }
      }).finally(() => this.loading = false)
    },
    confirm() {
      this.$refs.form.validate(valid => {
        if (valid) this.save()
      })
    }
  }
}
</script>